export var IMessageTypes;
(function (IMessageTypes) {
    IMessageTypes["message"] = "message";
    IMessageTypes["template_standard_event"] = "template/standard-event";
    IMessageTypes["template_minimal"] = "template/minimal";
    IMessageTypes["template_form"] = "template/form";
    IMessageTypes["template_custom"] = "template/custom";
})(IMessageTypes || (IMessageTypes = {}));
export var OfflineChannelId;
(function (OfflineChannelId) {
    OfflineChannelId["Email"] = "Email";
    OfflineChannelId["Facebook"] = "Facebook";
    OfflineChannelId["SMS"] = "SMS";
    OfflineChannelId["Whatsapp"] = "Whatsapp";
    OfflineChannelId["Phone"] = "Phone";
})(OfflineChannelId || (OfflineChannelId = {}));
